import { Badge, BadgeProps } from '@fluentui/react-components';

import { SEVERITY_LABEL, SEVERITY_ORDER } from '../../constants';
import { TFindingSummary } from '../../helpers';
import { TReviewSeverity } from '../../types';

const SEVERITY_COLOR: Record<TReviewSeverity, BadgeProps['color']> = {
  major: 'danger',
  minor: 'warning',
  needsReview: 'informative',
};

type TProps = {
  summary: Pick<TFindingSummary, 'total' | 'bySeverity'>;
  size?: BadgeProps['size'];
};

// Compact open-findings readout used in the register and in list headers.
export const SeverityCounts = ({ summary, size = 'small' }: TProps) => {
  const visible = SEVERITY_ORDER.filter((severity) => summary.bySeverity[severity] > 0);

  if (visible.length === 0) {
    return (
      <Badge appearance="outline" color="success" size={size}>
        {summary.total > 0 ? 'All handled' : 'No findings'}
      </Badge>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((severity) => (
        <Badge key={severity} appearance="tint" color={SEVERITY_COLOR[severity]} size={size}>
          {summary.bySeverity[severity]} {SEVERITY_LABEL[severity]}
        </Badge>
      ))}
    </div>
  );
};
